import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../CommonUtils/httpBodyOptions';
import { useClientId } from '../../../../../_hooks/useClientId';
import { queryKeys } from '../../../../api/queryKeys';
import { useFpId } from '../../../../hooks/useFpId';
import { useIsPdf } from '../../../../hooks/useIsPdf';
import type { EssentialTeamRoleDTO } from '../../../../types/goalsDTO';

const upsertEssentialTeamRole = (clientId: number) => (role: EssentialTeamRoleDTO) =>
  authFetch(
    '/Consumer/EstatePlanningEssentialRole/UpsertEstatePlanningEssentialTeamRole',
    {
      method: 'POST',
      ...httpBodyOptions(
        {
          clientId,
          Role: {
            Id: role.Id,
            PredefinedKey: role.PredefinedKey ?? '',
            RoleName: role.RoleName,
            Name: role.Name,
            Email: role.Email ?? '',
            PhoneNumber: role.PhoneNumber ?? '',
            Description: role.Description ?? '',
          },
        },
        false,
      ),
    },
  );

export const useUpsertEssentialRoleMutation = () => {
  const queryClient = useQueryClient();
  const clientId = useClientId();
  const fpId = useFpId();
  const isPdf = useIsPdf();

  return useMutation(upsertEssentialTeamRole(clientId), {
    async onSuccess() {
      await queryClient.invalidateQueries(queryKeys.financialPlan(clientId, fpId, isPdf));
    },
  });
};
